/**
 * Returns a duration of the voucher
 * @param code The voucher code.
 * @return {number} The resulting duration.
 */
export default function(code) {
  const duration = Number(code.slice(1, 3));
  return isNaN(duration) ? 0 : duration;
}
